import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { config } from "./config/env";

if (config.REACT_APP_POSTHOG_TOKEN) {
  posthog.init(config.REACT_APP_POSTHOG_TOKEN, {
    api_host: config.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
    defaults: "2025-05-24",
    capture_exceptions: true,
  });
  posthog.register({
    environment: config.REACT_APP_ENVIRONMENT,
    app_name: "transfer",
  });
}

const root = ReactDOM.createRoot(document.getElementById("root")!);

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PostHogProvider client={posthog}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PostHogProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
